<template>
  <v-row class="justify-center py-12">
    <v-card :width="$vuetify.display.mobile ? `100%` : `50%`" :max-width="$vuetify.display.mobile ? `100%` : `50%`"
      :loading="loading" :disabled="loading">
      <v-window v-model="tab">
        <v-window-item value="one">
          <v-card-title class="mt-4">BELÉPÉS</v-card-title>
          <v-card-actions style="padding: 1rem">
            <v-row class="justify-space-between align-center">
              <v-col cols="12">
                <div class="font-italic font-weight-medium text-center"
                  :class="$vuetify.display.mobile ? `text-center` : `text-left`">
                  Lépj be Google fiókoddal! Kattints a gombra!
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="consent" validate-on="input">
                  <template #label>
                    <label>
                      A mező bejelölésével Ön nyilatkozik, hogy adatai kezelését
                      illetően a Rákóczi Szövetség
                      <a :href="tou" target="_blank" style="color: black; text-decoration: underline">Adatkezelési
                        Tájékoztatójában</a>
                      és
                      <a :href="dmr" target="_blank" style="color: black; text-decoration: underline">Adatvédelmi
                        Szabályzatában</a>
                      foglaltak szerint keletkező jogait és kötelezettségeit
                      megismerte és elfogadja.
                    </label>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-alert density="compact" icon="mdi-information" title="FIGYELEM!"
                  text="A csapat tagjai a regisztráló Google-fiókkal, vagy az alább beállítható közös csapatjelszóval léphetnek be saját eszközeikről is."
                  color="rsz50" style="text-align: start"></v-alert>
              </v-col>

              <v-col cols="12">
                <v-btn size="large" class="w-100" variant="outlined" @click="googleAuth" :disabled="!consent">
                  <SvgComponent :size="24" name="google"></SvgComponent>
                  <span class="ml-4">GOOGLE BELÉPÉS / REGISZTRÁCIÓ</span>
                </v-btn>
              </v-col>

              <v-col cols="12">
                <div class="d-flex align-center my-2">
                  <v-divider></v-divider>
                  <span class="mx-3 text-medium-emphasis">vagy csapatjelszóval</span>
                  <v-divider></v-divider>
                </div>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  type="text"
                  label="Email"
                  placeholder="Csapat email címe"
                  variant="underlined"
                  :error="shouldErr"
                  v-model="dataForm.email"
                ></v-text-field>
                <v-text-field
                  type="password"
                  label="Jelszó"
                  placeholder="Csapatjelszó"
                  variant="underlined"
                  :error="shouldErr"
                  :error-messages="errorMessage"
                  v-model="dataForm.password"
                  @keyup.enter="loginUser"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn size="large" class="w-100" variant="outlined" @click="loginUser"
                  :disabled="!consent || !dataForm.email || !dataForm.password">
                  <span class="ml-4">BELÉPÉS CSAPATJELSZÓVAL</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-window-item>
      </v-window>
    </v-card>
  </v-row>
  <SaveDialog :text="modal.message" :okay-text="modal.okText" :showdialog="modal.shouldShow" />
</template>

<script>
import { defineComponent } from 'vue'
import SvgComponent from './SvgComponent.vue'
import tou from '../assets/RakocziSzovetseg_AdatkezelesiTajekoztato.pdf'
import { googleTokenLogin } from "vue3-google-login"
import dmr from '../assets/RakocziSzovetseg_Adatvedelm_es_Kozerdeku_Adatok_Megismeresenek_Rendejerol_sz_Szabalyzat20211221.pdf'
import { login, loginPw } from '../services/userServices'
import SaveDialog from './SaveDialog.vue'

export default defineComponent({
  name: `AuthComponent`,
  components: { SvgComponent, SaveDialog },
  data() {
    return {
      dataForm: {
        email: null,
        password: null,
      },
      loading: null,
      tab: null,
      consent: null,
      formComplete: false,
      verifyMsg: false,
      tou: tou,
      dmr: dmr,
      shouldErr: false,
      errorMessage: null,
      modal: {
        shouldShow: false,
        message: 'Sikeres regisztráció, kérem aktiválja a fiókját. Az aktivációs emailt keresse a spam között is.',
        okText: 'Rendben',
      }
    }
  },
  methods: {
    handleDialogChange(value) {
      this.modal.shouldShow = value;
    },
    async googleAuth() {
      if(process.env.VUE_APP_ENV == 'dev'){
        if((await login('access_token')).data){
          await this.$router.push('competitions')
        }else{
          console.log('Sikertelen bejelentkezés')
        }
        window.location.reload()
        return
      }

      googleTokenLogin().then(async (response) => {
        if((await login(response.access_token)).data){
          await this.$router.push('competitions')
          window.location.reload()
        }else{
          console.log('Sikertelen bejelentkezés')
        }
      })
    },
    async loginUser() {
      this.shouldErr = false
      this.errorMessage = null
      const resp = await loginPw(this.dataForm.email, this.dataForm.password)
      if(!resp || resp.data?.isErr){
        this.shouldErr = true
        this.errorMessage = resp?.data?.message || 'Hibás email vagy jelszó'
        return
      }
      await this.$router.push('competitions')
      window.location.reload()
    },

  },
})
</script>

<style></style>
